function BookingCancelled(email, evaluation) {
    $("#cancelled-booking-email").text(email);
    $("#cancelled-booking-evaluation-name").text(evaluation);
};